import {
    TRANSACTIONSUBTYPES_FAILED,
    TRANSACTIONSUBTYPES_SUCCESS,
    RESET_TRANSACTIONSUBTYPES,
    LOADING_TRANSACTIONSUBTYPES,
    NETWORK_ERROR_TRANSACTIONSUBTYPES
} from '../types/index';

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};


export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_TRANSACTIONSUBTYPES:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case TRANSACTIONSUBTYPES_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case TRANSACTIONSUBTYPES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_TRANSACTIONSUBTYPES:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_TRANSACTIONSUBTYPES:
            return (state = initialState);
        default:
            return state;
    }
};